<template>
	<div class="loginWrapper">
		<!-- <iris-pay-modal-popup :customerId="0" :order="order" /> -->
		<div id="modal_popup_error" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_error', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-if="this.orderError" v-html="$t('orderError_' + this.orderError.code)"></p>
			</div>
		</div>
		<div id="modal_popup_info" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_info', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-html="$t('orderPayRedirect')"></p>
				<!-- <p v-if="this.newOrder.successLink && this.orderStep === 4" v-html="$t('actionUploadFileSuccess')"></p> -->
			</div>
		</div>
		<div id="modal_popup_loading" class="modal-popup">
			<div class="modal-popup-content">
				<img src="@/assets/images/loading.gif" />
				<p v-html="$t('loadingPopupMessage')"></p>
			</div>
		</div>
	</div>
</template>

<script>
import httpService from "../http/http-common.js";
// import IrisPayModalPopup from "@/components/company/IrisPayModalPopup.vue";
import utils from "../plugins/utils.js";

export default {
	name: "order_payment",
	props: {
		msg: String,
	},
	// components: {
	// 	IrisPayModalPopup,
	// },
	data() {
		return {
			token: null,
			payload: null,
			order: null,
			orderError: {},
		};
	},
	methods: {
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		payOrder() {
			this.showModalPopup("modal_popup_loading", true);
			this.showModalPopup("modal_popup_info", false);
			// pay order
			let payload = {
				instructedAmount: 0.0,
				remmittanceInfo: { unstructured1: this.order.id + "" },
			};
			httpService.companyService
				.unauthorizedOrderPayment(this.order.id, this.token, payload)
				.then(function (response) {
					// handle success
					return response;
				})
				.catch(function (response) {
					// handle success
					return response.response;
				})
				.then((response) => {
					if (response.status === 200) {
						if (response.data.resp) {
							this.showModalPopup("modal_popup_info", true);

							window.open(response.data.resp.bankSelectionToolUrl, "_blank");
						} else {
							this.orderError = {
								code: "PAYMENT",
								description: "Error paying order",
							};
							this.showModalPopup("modal_popup_error", true);
						}
					} else if (response.status === 400 || response.status === 403) {
						this.orderError = {
							code: response.data.error_code,
							description: "Error paying order",
						};
						this.showModalPopup("modal_popup_error", true);

					} else {
						this.orderError = {
							code: "PAYMENT",
							description: "Error paying order",
						};
						this.showModalPopup("modal_popup_error", true);
					}
					this.showModalPopup("modal_popup_loading", false);
				});
		},
		async getToken() {
			await httpService.companyService
				.requestTokenForRegistration("webopen")
				.then(function (response) {
					// handle success
					return response.data;
				})
				.then((data) => {
					this.token = data.access_token;
					this.payOrder();
				})
				.catch(function () {
					// handle success
				});
		},
	},
	mounted() {
		// const isProd = process.env.NODE_ENV === "production";
		// if (!isProd) {
		let orderId = utils.getUrlParam("orderId");
		if (orderId !== null) {
			this.payload = {
				remmittanceInfo: { unstructured1: orderId },
			};
			this.order = { id: orderId };
			this.getToken();
		} else {
			this.payload = null;
		}
		// }
	},
};
</script>
<style scoped src="@/assets/styles/login.css">

</style>
